import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from", "elapsed"];
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined(_ref) {
  var when = _ref.when,
    _delay = _ref.delay,
    delayChildren = _ref.delayChildren,
    staggerChildren = _ref.staggerChildren,
    staggerDirection = _ref.staggerDirection,
    repeat = _ref.repeat,
    repeatType = _ref.repeatType,
    repeatDelay = _ref.repeatDelay,
    from = _ref.from,
    elapsed = _ref.elapsed,
    transition = _objectWithoutProperties(_ref, _excluded);
  return !!Object.keys(transition).length;
}
function getValueTransition(transition, key) {
  return transition[key] || transition["default"] || transition;
}
export { getValueTransition, isTransitionDefined };